import React from 'react';
import {
  PanelLeftClose, PanelLeft,
  Share2, Download, FileDown, Phone,
} from 'lucide-react';
import { Logo, GUEST_MSG_LIMIT } from './chatUtils';
import { ThemeToggle } from '../../context/ThemeContext';

export default function ChatHeader({
  activeSession, messages, sidebarOpen, setSidebarOpen,
  isGuest, guestMsgCount, onShare, onExport, onTalkMode,
}) {
  const remainingMsgs = isGuest ? Math.max(0, GUEST_MSG_LIMIT - guestMsgCount) : null;

  return (
    <header className="flex items-center justify-between px-4 md:px-5 py-3 border-b border-line flex-shrink-0 bg-app/80 backdrop-blur-xl" data-testid="chat-header">
      <div className="flex items-center gap-3 min-w-0">
        <button onClick={() => setSidebarOpen(!sidebarOpen)} className="p-2 rounded-xl hover:bg-overlay-hover text-content-3 transition-colors active:scale-95" data-testid="toggle-sidebar-btn">
          {sidebarOpen ? <PanelLeftClose className="w-5 h-5" strokeWidth={1.5} /> : <PanelLeft className="w-5 h-5" strokeWidth={1.5} />}
        </button>
        <div className="flex items-center gap-2">
          <Logo size="sm" />
          <h2 className="text-[13px] font-sora font-medium text-content-2 truncate max-w-[200px] md:max-w-none">
            {activeSession?.title || 'OpenSov AI'}
          </h2>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <ThemeToggle />
        {isGuest && remainingMsgs !== null && remainingMsgs <= 3 && (
          <span className="text-[10px] px-2.5 py-1 rounded-full mr-1 bg-amber-500/10 text-amber-400 border border-amber-500/20 font-mono" data-testid="msg-counter">
            {remainingMsgs} left
          </span>
        )}

        <button onClick={onTalkMode}
          className="p-2 rounded-xl hover:bg-overlay-hover transition-colors active:scale-95 text-content-3 hover:text-emerald-500"
          data-testid="talk-mode-btn" title="Talk to OpenSov AI">
          <Phone className="w-[18px] h-[18px]" strokeWidth={1.5} />
        </button>

        {activeSession && messages.length > 0 && (
          <>
            <button onClick={onShare}
              className="p-2 rounded-xl hover:bg-overlay-hover text-content-3 hover:text-content-2 transition-colors active:scale-95"
              data-testid="share-btn" title="Share conversation">
              <Share2 className="w-[18px] h-[18px]" strokeWidth={1.5} />
            </button>
            <div className="relative group">
              <button
                className="p-2 rounded-xl hover:bg-overlay-hover text-content-3 hover:text-content-2 transition-colors active:scale-95"
                data-testid="export-btn" title="Export conversation">
                <Download className="w-[18px] h-[18px]" strokeWidth={1.5} />
              </button>
              <div className="absolute right-0 top-full mt-1 w-44 rounded-xl border shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 bg-surface border-line">
                <button onClick={() => onExport('pdf')}
                  className="flex items-center gap-2.5 w-full px-4 py-3 text-[13px] rounded-t-xl hover:bg-overlay-hover transition-colors text-content-2 font-sora"
                  data-testid="export-pdf-btn">
                  <FileDown className="w-3.5 h-3.5 text-content-3" strokeWidth={1.5} /> Export as PDF
                </button>
                <button onClick={() => onExport('docx')}
                  className="flex items-center gap-2.5 w-full px-4 py-3 text-[13px] rounded-b-xl hover:bg-overlay-hover transition-colors text-content-2 font-sora"
                  data-testid="export-docx-btn">
                  <FileDown className="w-3.5 h-3.5 text-content-3" strokeWidth={1.5} /> Export as DOCX
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
